export default function LastActionReducer(state = null, action) {
  return action;
}
